import { render, staticRenderFns } from "./welcome-message.vue?vue&type=template&id=6811f5ba&scoped=true&"
import script from "./welcome-message.vue?vue&type=script&lang=js&"
export * from "./welcome-message.vue?vue&type=script&lang=js&"
import style0 from "./welcome-message.vue?vue&type=style&index=0&id=6811f5ba&scoped=true&lang=css&"
import style1 from "./welcome-message.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6811f5ba",
  null
  
)

export default component.exports